import { WPTypography } from "../WPTypography";

import { combineClassNames } from "../../utils/appUtils";

import "./WPInputLabel.scss";

const WPInputLabel = ({ id, label, disabled, className, required }) => (
  <>
    {label && (
      <label className={combineClassNames("wp-input-label fs-14", disabled && "disabled", className)} htmlFor={id}>
        {required && <WPTypography text='*' asElement='span' className='wp-input-required' />}
        {label}
      </label>
    )}
  </>
);

export default WPInputLabel;
